// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"e31097d5","209":"a5c04d15","453":"e655467b"}[chunkId] + ".chunk.js";
};